import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  enhanceCommentFailure,
  enhanceCommentSuccess,
  enhanceFeedFailure,
  enhanceFeedSuccess,
} from "./actions";
import { ENHANCE_COMMENT, ENHANCE_FEED } from "./constants";

export function* enhanceCommentSaga({ payload }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  const { data, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/survey/comment/polish`,
      data,
    );
    yield put(enhanceCommentSuccess());
    typeof onSuccess === "function" && onSuccess(response?.data);
  } catch (e) {
    yield put(enhanceCommentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* enhanceFeedSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data } = payload;
  try {
    const response = yield call(api(token).post, `/api/feed/ai-enhance`, data);
    yield put(enhanceFeedSuccess());
    typeof onSuccess === "function" && onSuccess(response?.data);
  } catch (e) {
    yield put(enhanceFeedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* enhanceCommentFlow() {
  yield takeEvery(ENHANCE_COMMENT, enhanceCommentSaga);
}

export function* enhanceFeedFlow() {
  yield takeEvery(ENHANCE_FEED, enhanceFeedSaga);
}

export default function* AISaga() {
  yield all([enhanceCommentFlow(), enhanceFeedFlow()]);
}
